export default __webpack_public_path__ + "static/media/sEUR.f8130fce.png";